
import { Avatar } from "@/components/ui/avatar";
import { Linkedin } from "lucide-react";

interface BlogAuthorProps {
  name: string;
  role?: string;
  bio?: string;
  avatarUrl?: string;
  linkedinUrl?: string;
  compact?: boolean;
}

export const BlogAuthor = ({ 
  name, 
  role = "Security Professional", 
  bio, 
  avatarUrl,
  linkedinUrl,
  compact = false
}: BlogAuthorProps) => {
  if (!name) return null;
  
  if (compact) {
    return (
      <div className="flex items-center">
        <Avatar className="h-9 w-9 bg-edgefi-amethyst/20 text-edgefi-purple border border-edgefi-amethyst/20">
          {avatarUrl ? (
            <img src={avatarUrl} alt={name} className="h-full w-full object-cover" />
          ) : (
            <span className="font-medium">{name[0]}</span>
          )}
        </Avatar>
        <div className="ml-2">
          <p className="text-sm font-medium">{name}</p>
          {role && <p className="text-xs text-gray-500">{role}</p>}
        </div>
      </div>
    );
  }
  
  return (
    <div className="bg-edgefi-white rounded-xl p-6 border border-edgefi-amethyst/20">
      <div className="flex items-start md:items-center flex-col md:flex-row">
        <Avatar className="h-16 w-16 bg-edgefi-amethyst/20 text-edgefi-purple border-2 border-white text-xl">
          {avatarUrl ? (
            <img src={avatarUrl} alt={name} className="h-full w-full object-cover" />
          ) : (
            <span className="font-bold">{name[0]}</span>
          )}
        </Avatar>
        <div className="md:ml-5 mt-4 md:mt-0">
          <h3 className="text-xl font-bold text-edgefi-black">{name}</h3>
          <p className="text-gray-600 mb-3">{role} at edgefi</p>
          {bio && <p className="text-sm text-gray-700">{bio}</p>}
          
          {linkedinUrl && (
            <a 
              href={linkedinUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-blue-600 flex items-center mt-2 hover:underline"
            >
              <Linkedin className="h-4 w-4 mr-1" />
              Connect on LinkedIn
            </a>
          )}
        </div>
      </div>
    </div>
  );
};
